"use client";

import { useAppContext } from "@/context/AppContext";
import { useSessionContext } from "@/context/SessionContext";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

const PROTECTED_PATHS = ["/logy"] as const;

function isProtectedPath(pathname: string) {
  return PROTECTED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function Auth({ children }: { children: React.ReactNode }) {
  const { isLoggedIn } = useAppContext();
  const { isInitialLoading } = useSessionContext();
  const pathname = usePathname();
  const router = useRouter();
  const shouldRedirect =
    !isInitialLoading && !isLoggedIn && isProtectedPath(pathname);

  useEffect(() => {
    if (shouldRedirect) {
      router.replace("/");
    }
  }, [router, shouldRedirect]);

  if (shouldRedirect) {
    return null;
  }

  return <>{children}</>;
}
